/* WARNING: This file is auto-generated . Do not edit manually. */

import { DedicatedServerInstallCustom } from '../models/DedicatedServerInstallCustom';
import { DedicatedServerSmsAlert } from '../models/DedicatedServerSmsAlert';
import { DedicatedAvailabilities } from '../models/DedicatedAvailabilities';
import { DedicatedServerRtmRaidVolumePort } from '../models/DedicatedServerRtmRaidVolumePort';
import { DedicatedServerIpmi } from '../models/DedicatedServerIpmi';
import { DedicatedServerHardwareRaidSize } from '../models/DedicatedServerHardwareRaidSize';
import { DedicatedDatacenterAvailability } from '../models/DedicatedDatacenterAvailability';
import { DedicatedServerOptionEnum } from '../models/DedicatedServerOptionEnum';
import { DedicatedServerNetbootOption } from '../models/DedicatedServerNetbootOption';
import { DedicatedServerServerBurst } from '../models/DedicatedServerServerBurst';
import { DedicatedServerBackupBackupPassword } from '../models/DedicatedServerBackupBackupPassword';
import { DedicatedServerRtmDisk } from '../models/DedicatedServerRtmDisk';
import { DedicatedBiosSettingsBiosSettings } from '../models/DedicatedBiosSettingsBiosSettings';
import { DedicatedVirtualNetworkInterfaceVirtualNetworkInterfaceModeEnum } from '../models/DedicatedVirtualNetworkInterfaceVirtualNetworkInterfaceModeEnum';
import { DedicatedServerRtmChartTypeEnum } from '../models/DedicatedServerRtmChartTypeEnum';
import { DedicatedDatacenterRawAvailability } from '../models/DedicatedDatacenterRawAvailability';
import { DedicatedServerRtmCommandSize } from '../models/DedicatedServerRtmCommandSize';
import { DedicatedServerSpla } from '../models/DedicatedServerSpla';
import { DedicatedVirtualNetworkInterfaceVirtualNetworkInterface } from '../models/DedicatedVirtualNetworkInterfaceVirtualNetworkInterface';
import { DedicatedServerConfigDrive } from '../models/DedicatedServerConfigDrive';
import { DedicatedServerFirewall } from '../models/DedicatedServerFirewall';
import { DedicatedServerNetworkSpecifications } from '../models/DedicatedServerNetworkSpecifications';
import { DedicatedServerKvm } from '../models/DedicatedServerKvm';
import { DedicatedServerTemplateCaps } from '../models/DedicatedServerTemplateCaps';
import { DedicatedServerRtmConnection } from '../models/DedicatedServerRtmConnection';
import { LicenseWindowsOsVersionEnum } from '../models/LicenseWindowsOsVersionEnum';
import { DedicatedServerBackupBackupOffer } from '../models/DedicatedServerBackupBackupOffer';
import { DedicatedServerBackupStorageOrderable } from '../models/DedicatedServerBackupStorageOrderable';
import { DedicatedServerBackupCloud } from '../models/DedicatedServerBackupCloud';
import { DedicatedServerMonitoringIntervalEnum } from '../models/DedicatedServerMonitoringIntervalEnum';
import { ServiceTerminationFutureUseEnum } from '../models/ServiceTerminationFutureUseEnum';
import { VrackTask } from '../models/VrackTask';
import { DedicatedPublicLog } from '../models/DedicatedPublicLog';
import { DedicatedBiosSettingsSgxBiosSettingsSgx } from '../models/DedicatedBiosSettingsSgxBiosSettingsSgx';
import { DedicatedServerSplaTypeEnum } from '../models/DedicatedServerSplaTypeEnum';
import { DedicatedServerBackupFtpAcl } from '../models/DedicatedServerBackupFtpAcl';
import { LicenseWindowsSqlVersionEnum } from '../models/LicenseWindowsSqlVersionEnum';
import { DedicatedServerHardwareRaidProfile } from '../models/DedicatedServerHardwareRaidProfile';
import { DedicatedServerMrtgPeriodEnum } from '../models/DedicatedServerMrtgPeriodEnum';
import { DedicatedServerBootTypeEnum } from '../models/DedicatedServerBootTypeEnum';
import { DedicatedNetworkInterfaceControllerNetworkInterfaceControllerLinkTypeEnum } from '../models/DedicatedNetworkInterfaceControllerNetworkInterfaceControllerLinkTypeEnum';
import { SecondaryDnsSecondaryDNS } from '../models/SecondaryDnsSecondaryDNS';
import { DedicatedServerRtmMemory } from '../models/DedicatedServerRtmMemory';
import { DedicatedServerTask } from '../models/DedicatedServerTask';
import { DedicatedBinaryFirewallLink } from '../models/DedicatedBinaryFirewallLink';
import { DedicatedServerBiosSettingsSgxStatusEnum } from '../models/DedicatedServerBiosSettingsSgxStatusEnum';
import { DedicatedTaskFunctionEnum } from '../models/DedicatedTaskFunctionEnum';
import { DedicatedImageTypesEnum } from '../models/DedicatedImageTypesEnum';
import { DedicatedServerVmacTypeEnum } from '../models/DedicatedServerVmacTypeEnum';
import { DedicatedServerEmailAlert } from '../models/DedicatedServerEmailAlert';
import { SecondaryDnsSecondaryDNSCheckField } from '../models/SecondaryDnsSecondaryDNSCheckField';
import { DedicatedServerSplaStatusEnum } from '../models/DedicatedServerSplaStatusEnum';
import { DedicatedPlannedInterventionTimeSlot } from '../models/DedicatedPlannedInterventionTimeSlot';
import { ServiceTerminationReasonEnum } from '../models/ServiceTerminationReasonEnum';
import { DedicatedServerUsbKeyOrderableDetails } from '../models/DedicatedServerUsbKeyOrderableDetails';
import { DedicatedServerRtmDiskSmart } from '../models/DedicatedServerRtmDiskSmart';
import { SupportNewMessageInfo } from '../models/SupportNewMessageInfo';
import { DedicatedServerIpOrderable } from '../models/DedicatedServerIpOrderable';
import { DedicatedServerRtmChartPeriodEnum } from '../models/DedicatedServerRtmChartPeriodEnum';
import { DedicatedServerRtmLoad } from '../models/DedicatedServerRtmLoad';
import { DedicatedServerBiosSettingsSgxPrmrrEnum } from '../models/DedicatedServerBiosSettingsSgxPrmrrEnum';
import { DedicatedServerBandwidthOrderable } from '../models/DedicatedServerBandwidthOrderable';
import { DedicatedServerInstallationProgressStatus } from '../models/DedicatedServerInstallationProgressStatus';
import { ServicesService } from '../models/ServicesService';
import { DedicatedServerSupportReplaceHddInfo } from '../models/DedicatedServerSupportReplaceHddInfo';
import { DedicatedServerNetboot } from '../models/DedicatedServerNetboot';
import { DedicatedExposedTask } from '../models/DedicatedExposedTask';
import { DedicatedServerIpCountryEnum } from '../models/DedicatedServerIpCountryEnum';
import { ComplexTypeChartReturn } from '../models/ComplexTypeChartReturn';
import { DedicatedBinaryFirewall } from '../models/DedicatedBinaryFirewall';
import { DedicatedServerVirtualMacManagement } from '../models/DedicatedServerVirtualMacManagement';
import { DedicatedServerPlannedIntervention } from '../models/DedicatedServerPlannedIntervention';
import { DedicatedServerServiceMonitoring } from '../models/DedicatedServerServiceMonitoring';
import { DedicatedServerOption } from '../models/DedicatedServerOption';
import { DedicatedServerIntervention } from '../models/DedicatedServerIntervention';
import { DedicatedServerAlertLanguageEnum } from '../models/DedicatedServerAlertLanguageEnum';
import { NichandleOvhSubsidiaryEnum } from '../models/NichandleOvhSubsidiaryEnum';
import { DedicatedServerByoiStatus } from '../models/DedicatedServerByoiStatus';
import { DedicatedAvailabilitiesRaw } from '../models/DedicatedAvailabilitiesRaw';
import { DedicatedServerInstallTemplate } from '../models/DedicatedServerInstallTemplate';
import { SecondaryDnsSecondaryDNSNameServer } from '../models/SecondaryDnsSecondaryDNSNameServer';
import { DedicatedServerOrderableSysFeatureEnum } from '../models/DedicatedServerOrderableSysFeatureEnum';
import { DedicatedServerRtmMotherboardHw } from '../models/DedicatedServerRtmMotherboardHw';
import { DedicatedServerRtmPartition } from '../models/DedicatedServerRtmPartition';
import { DedicatedServerMonitoringProtocolEnum } from '../models/DedicatedServerMonitoringProtocolEnum';
import { DedicatedServerMrtgTimestampValue } from '../models/DedicatedServerMrtgTimestampValue';
import { DedicatedCheckSumTypesEnum } from '../models/DedicatedCheckSumTypesEnum';
import { DedicatedServerAccess } from '../models/DedicatedServerAccess';
import { DedicatedServerIpmiTestResult } from '../models/DedicatedServerIpmiTestResult';
import { DedicatedServerRtmCpu } from '../models/DedicatedServerRtmCpu';
import { DedicatedTaskStatusEnum } from '../models/DedicatedTaskStatusEnum';
import { DedicatedServerBandwidthvRackOrderable } from '../models/DedicatedServerBandwidthvRackOrderable';
import { DedicatedServerIpmiTestTypeEnum } from '../models/DedicatedServerIpmiTestTypeEnum';
import { DedicatedNetworkInterfaceControllerNetworkInterfaceController } from '../models/DedicatedNetworkInterfaceControllerNetworkInterfaceController';
import { DedicatedServerCacheTTLEnum } from '../models/DedicatedServerCacheTTLEnum';
import { DedicatedServerHardwareSpecifications } from '../models/DedicatedServerHardwareSpecifications';
import { DedicatedServerRtmOs } from '../models/DedicatedServerRtmOs';
import { DedicatedServerTrafficOrderable } from '../models/DedicatedServerTrafficOrderable';
import { DedicatedServerIpmiAccessValue } from '../models/DedicatedServerIpmiAccessValue';
import { DedicatedServerBootOptionEnum } from '../models/DedicatedServerBootOptionEnum';
import { VrackDedicatedServer } from '../models/VrackDedicatedServer';
import { DedicatedServerRtmRaidVolume } from '../models/DedicatedServerRtmRaidVolume';
import { DedicatedServerRtmRaid } from '../models/DedicatedServerRtmRaid';
import { DedicatedServerIpmiAccessTypeEnum } from '../models/DedicatedServerIpmiAccessTypeEnum';
import { DedicatedServerDedicated } from '../models/DedicatedServerDedicated';
import { DedicatedServerVirtualMac } from '../models/DedicatedServerVirtualMac';
import { DedicatedDatacenterEnum } from '../models/DedicatedDatacenterEnum';
import { DedicatedServerBackupFtp } from '../models/DedicatedServerBackupFtp';
import { DedicatedServerMrtgTypeEnum } from '../models/DedicatedServerMrtgTypeEnum';
import { DedicatedServerRtm } from '../models/DedicatedServerRtm';
import { DedicatedServerRtmPci } from '../models/DedicatedServerRtmPci';
import OVHBase from '../ovh';

class DedicatedServerHandler {
  ovh: OVHBase;

  constructor(ovh: OVHBase) {
    this.ovh = ovh;
  }

  /** List available services */
  listServer = (): Promise<string[]> => {
    return this.ovh.request('GET', '/dedicated/server');
  };

  /** List the availability of dedicated server */
  listServerAvailabilities = (): Promise<DedicatedAvailabilities[]> => {
    return this.ovh.request('GET', '/dedicated/server/availabilities');
  };

  /** List the availability of dedicated server */
  listServerAvailabilitiesRaw = (): Promise<DedicatedAvailabilitiesRaw[]> => {
    return this.ovh.request('GET', '/dedicated/server/availabilities/raw');
  };

  /** List the availability of dedicated server */
  listServerDatacenterAvailabilities = (): Promise<DedicatedDatacenterAvailability[]> => {
    return this.ovh.request('GET', '/dedicated/server/datacenter/availabilities');
  };

  /** List the raw availability of dedicated server */
  listServerDatacenterAvailabilitiesRaw = (): Promise<DedicatedDatacenterRawAvailability[]> => {
    return this.ovh.request('GET', '/dedicated/server/datacenter/availabilities/raw');
  };

  /** Get public logs for servers */
  getServerLog = (): Promise<DedicatedPublicLog> => {
    return this.ovh.request('GET', '/dedicated/server/log');
  };

  /** List the os available for a specified hardware reference */
  listServerOsAvailabilities = (): Promise<string[]> => {
    return this.ovh.request('GET', '/dedicated/server/osAvailabilities');
  };

  /** Get VirtualNetworkInterface details */
  getServerVirtualNetworkInterfaceByUuid = (
    uuid: string
  ): Promise<DedicatedVirtualNetworkInterfaceVirtualNetworkInterface> => {
    return this.ovh.request('GET', `/dedicated/server/virtualNetworkInterface/${uuid}`);
  };

  /** Get this object properties */
  getServerByServiceName = (serviceName: string): Promise<DedicatedServerDedicated> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}`);
  };

  /** Alter this object properties */
  updateServerByServiceName = (
    serviceName: string,
    body: DedicatedServerDedicated
  ): Promise<void> => {
    return this.ovh.request('PUT', `/dedicated/server/${serviceName}`, body);
  };

  /** Retrieve secret to connect to the server / application */
  postServerAuthenticationSecretByServiceName = (
    serviceName: string
  ): Promise<DedicatedServerAccess[]> => {
    return this.ovh.request('POST', `/dedicated/server/${serviceName}/authenticationSecret`);
  };

  /** Get details on offered backup cloud if available for the current server */
  getServerBackupCloudOfferDetailsByServiceName = (
    serviceName: string
  ): Promise<DedicatedServerBackupBackupOffer> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/backupCloudOfferDetails`);
  };

  /** Get this object properties */
  getServerBiosSettingsByServiceName = (
    serviceName: string
  ): Promise<DedicatedBiosSettingsBiosSettings> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/biosSettings`);
  };

  /** Get this object properties */
  getServerBiosSettingsSgxByServiceName = (
    serviceName: string
  ): Promise<DedicatedBiosSettingsSgxBiosSettingsSgx> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/biosSettings/sgx`);
  };

  /** Enable or disable SGX and configure PRMRR size. This will cause your server to reboot one or several time(s). */
  enableServerBiosSettingsSgxConfigureByServiceName = (
    serviceName: string,
    body: {
      prmrr?: DedicatedServerBiosSettingsSgxPrmrrEnum;
      status?: DedicatedServerBiosSettingsSgxStatusEnum;
    }
  ): Promise<DedicatedServerTask> => {
    return this.ovh.request(
      'POST',
      `/dedicated/server/${serviceName}/biosSettings/sgx/configure`,
      body
    );
  };

  /** Server compatibles netboots */
  getServerBootByServiceName = (serviceName: string): Promise<number[]> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/boot`);
  };

  /** Get this object properties */
  getServerBootByServiceNameAndBootId = (
    bootId: number,
    serviceName: string
  ): Promise<DedicatedServerNetboot> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/boot/${bootId}`);
  };

  /** Option used on this netboot */
  getServerBootOptionByServiceNameAndBootId = (
    bootId: number,
    serviceName: string
  ): Promise<DedicatedServerBootOptionEnum[]> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/boot/${bootId}/option`);
  };

  /** Get this object properties */
  getServerBootOptionByServiceNameAndBootIdAndOption = (
    bootId: number,
    option: DedicatedServerBootOptionEnum,
    serviceName: string
  ): Promise<DedicatedServerNetbootOption> => {
    return this.ovh.request(
      'GET',
      `/dedicated/server/${serviceName}/boot/${bootId}/option/${option}`
    );
  };

  /** Delete your current image installation */
  deleteServerBringYourOwnImageByServiceName = (serviceName: string): Promise<void> => {
    return this.ovh.request('DELETE', `/dedicated/server/${serviceName}/bringYourOwnImage`);
  };

  /** Get this object properties */
  getServerBringYourOwnImageByServiceName = (
    serviceName: string
  ): Promise<DedicatedServerByoiStatus> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/bringYourOwnImage`);
  };

  /** Start an install with your own image */
  postServerBringYourOwnImageByServiceName = (
    serviceName: string,
    body: {
      URL: string;
      checkSum?: string;
      checkSumType?: DedicatedCheckSumTypesEnum;
      configdrive?: DedicatedServerConfigDrive;
      description?: string;
      diskGroupId?: number;
      httpHeader?: string;
      type: DedicatedImageTypesEnum;
    }
  ): Promise<void> => {
    return this.ovh.request('POST', `/dedicated/server/${serviceName}/bringYourOwnImage`, body);
  };

  /** Get this object properties */
  getServerBurstByServiceName = (serviceName: string): Promise<DedicatedServerServerBurst> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/burst`);
  };

  /** Alter this object properties */
  updateServerBurstByServiceName = (
    serviceName: string,
    body: DedicatedServerServerBurst
  ): Promise<void> => {
    return this.ovh.request('PUT', `/dedicated/server/${serviceName}/burst`, body);
  };

  /** Launch a contact change procedure */
  launchServerChangeContactByServiceName = (
    serviceName: string,
    body: { contactAdmin?: string; contactBilling?: string; contactTech?: string }
  ): Promise<number[]> => {
    return this.ovh.request('POST', `/dedicated/server/${serviceName}/changeContact`, body);
  };

  /** Confirm termination of your service */
  confirmServerTerminationByServiceName = (
    serviceName: string,
    body: {
      commentary?: string;
      futureUse?: ServiceTerminationFutureUseEnum;
      reason?: ServiceTerminationReasonEnum;
      token: string;
    }
  ): Promise<string> => {
    return this.ovh.request('POST', `/dedicated/server/${serviceName}/confirmTermination`, body);
  };

  /** Deactivate the cloud backup associated to the server. This does not delete container data. */
  deleteServerFeaturesBackupCloudByServiceName = (serviceName: string): Promise<void> => {
    return this.ovh.request('DELETE', `/dedicated/server/${serviceName}/features/backupCloud`);
  };

  /** Get this object properties */
  getServerFeaturesBackupCloudByServiceName = (
    serviceName: string
  ): Promise<DedicatedServerBackupCloud> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/features/backupCloud`);
  };

  /** Create a new storage backup space associated to server */
  createServerFeaturesBackupCloudByServiceName = (
    serviceName: string,
    body: { cloudProjectId?: string; projectDescription?: string }
  ): Promise<DedicatedServerBackupCloud> => {
    return this.ovh.request('POST', `/dedicated/server/${serviceName}/features/backupCloud`, body);
  };

  /** Change your cloud account password */
  updateServerFeaturesBackupCloudPasswordByServiceName = (
    serviceName: string
  ): Promise<DedicatedServerBackupBackupPassword> => {
    return this.ovh.request(
      'POST',
      `/dedicated/server/${serviceName}/features/backupCloud/password`
    );
  };

  /** Terminate your Backup FTP service, ALL DATA WILL BE PERMANENTLY DELETED */
  deleteServerFeaturesBackupFTPByServiceName = (
    serviceName: string
  ): Promise<DedicatedServerTask> => {
    return this.ovh.request('DELETE', `/dedicated/server/${serviceName}/features/backupFTP`);
  };

  /** Get this object properties */
  getServerFeaturesBackupFTPByServiceName = (
    serviceName: string
  ): Promise<DedicatedServerBackupFtp> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/features/backupFTP`);
  };

  /** Create a new Backup FTP space */
  createServerFeaturesBackupFTPByServiceName = (
    serviceName: string
  ): Promise<DedicatedServerTask> => {
    return this.ovh.request('POST', `/dedicated/server/${serviceName}/features/backupFTP`);
  };

  /** List of IP blocks (and protocols to allow on these blocks) authorized on your backup FTP */
  listServerFeaturesBackupFTPAccessByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/features/backupFTP/access`);
  };

  /** Create a new Backup FTP ACL */
  createServerFeaturesBackupFTPAccessByServiceName = (
    serviceName: string,
    body: { cifs: boolean; ftp?: boolean; ipBlock: string; nfs: boolean }
  ): Promise<DedicatedServerTask> => {
    return this.ovh.request(
      'POST',
      `/dedicated/server/${serviceName}/features/backupFTP/access`,
      body
    );
  };

  /** Revoke this ACL */
  deleteServerFeaturesBackupFTPAccessByServiceNameAndIpBlock = (
    ipBlock: string,
    serviceName: string
  ): Promise<DedicatedServerTask> => {
    return this.ovh.request(
      'DELETE',
      `/dedicated/server/${serviceName}/features/backupFTP/access/${ipBlock}`
    );
  };

  /** Get this object properties */
  getServerFeaturesBackupFTPAccessByServiceNameAndIpBlock = (
    ipBlock: string,
    serviceName: string
  ): Promise<DedicatedServerBackupFtpAcl> => {
    return this.ovh.request(
      'GET',
      `/dedicated/server/${serviceName}/features/backupFTP/access/${ipBlock}`
    );
  };

  /** Alter this object properties */
  updateServerFeaturesBackupFTPAccessByServiceNameAndIpBlock = (
    ipBlock: string,
    serviceName: string,
    body: DedicatedServerBackupFtpAcl
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/dedicated/server/${serviceName}/features/backupFTP/access/${ipBlock}`,
      body
    );
  };

  /** Get all IP blocks that can be used in the ACL */
  getServerFeaturesBackupFTPAuthorizableBlocksByServiceName = (
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/dedicated/server/${serviceName}/features/backupFTP/authorizableBlocks`
    );
  };

  /** Change your Backup FTP password */
  updateServerFeaturesBackupFTPPasswordByServiceName = (
    serviceName: string
  ): Promise<DedicatedServerTask> => {
    return this.ovh.request('POST', `/dedicated/server/${serviceName}/features/backupFTP/password`);
  };

  /** Get this object properties */
  getServerFeaturesFirewallByServiceName = (
    serviceName: string
  ): Promise<DedicatedServerFirewall> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/features/firewall`);
  };

  /** Alter this object properties */
  updateServerFeaturesFirewallByServiceName = (
    serviceName: string,
    body: DedicatedServerFirewall
  ): Promise<void> => {
    return this.ovh.request('PUT', `/dedicated/server/${serviceName}/features/firewall`, body);
  };

  /** Get this object properties */
  getServerFeaturesIpmiByServiceName = (serviceName: string): Promise<DedicatedServerIpmi> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/features/ipmi`);
  };

  /** IPMI access method */
  getServerFeaturesIpmiAccessByServiceName = (
    serviceName: string
  ): Promise<DedicatedServerIpmiAccessValue> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/features/ipmi/access`);
  };

  /** Request an acces on KVM IPMI interface */
  postServerFeaturesIpmiAccessByServiceName = (
    serviceName: string,
    body: {
      ipToAllow?: string;
      sshKey?: string;
      ttl: DedicatedServerCacheTTLEnum;
      type: DedicatedServerIpmiAccessTypeEnum;
    }
  ): Promise<DedicatedServerTask> => {
    return this.ovh.request('POST', `/dedicated/server/${serviceName}/features/ipmi/access`, body);
  };

  /** Reset KVM IPMI interface */
  postServerFeaturesIpmiResetInterfaceByServiceName = (
    serviceName: string
  ): Promise<DedicatedServerTask> => {
    return this.ovh.request(
      'POST',
      `/dedicated/server/${serviceName}/features/ipmi/resetInterface`
    );
  };

  /** Reset KVM IPMI sessions */
  postServerFeaturesIpmiResetSessionsByServiceName = (
    serviceName: string
  ): Promise<DedicatedServerTask> => {
    return this.ovh.request('POST', `/dedicated/server/${serviceName}/features/ipmi/resetSessions`);
  };

  /** Result of http, ping and identification tests on IPMI interface */
  getServerFeaturesIpmiTestByServiceName = (
    serviceName: string
  ): Promise<DedicatedServerIpmiTestResult> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/features/ipmi/test`);
  };

  /** Launch test on KVM IPMI interface */
  launchServerFeaturesIpmiTestByServiceName = (
    serviceName: string,
    body: { ttl: DedicatedServerCacheTTLEnum; type: DedicatedServerIpmiTestTypeEnum }
  ): Promise<DedicatedServerTask> => {
    return this.ovh.request('POST', `/dedicated/server/${serviceName}/features/ipmi/test`, body);
  };

  /** Get this object properties */
  getServerFeaturesKvmByServiceName = (serviceName: string): Promise<DedicatedServerKvm> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/features/kvm`);
  };

  /** Get name binary for asa */
  getServerFirewallBinaryCompatibleByServiceName = (
    serviceName: string
  ): Promise<DedicatedBinaryFirewall> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/firewall/binary/compatible`);
  };

  /** Get url of binary to update firewall asa */
  getServerFirewallBinaryLinkByServiceName = (
    serviceName: string
  ): Promise<DedicatedBinaryFirewallLink> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/firewall/binary/link`);
  };

  /** Retrieve compatible  install template partitions scheme */
  getServerInstallCompatibleTemplatePartitionSchemesByServiceName = (
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/dedicated/server/${serviceName}/install/compatibleTemplatePartitionSchemes`
    );
  };

  /** Retrieve compatible  install templates names */
  getServerInstallCompatibleTemplatesByServiceName = (
    serviceName: string
  ): Promise<DedicatedServerInstallTemplate> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/install/compatibleTemplates`);
  };

  /** Retrieve hardware RAID profile */
  getServerInstallHardwareRaidProfileByServiceName = (
    serviceName: string
  ): Promise<DedicatedServerHardwareRaidProfile> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/install/hardwareRaidProfile`);
  };

  /** Get hardware RAID size for a given configuration */
  getServerInstallHardwareRaidSizeByServiceName = (
    serviceName: string
  ): Promise<DedicatedServerHardwareRaidSize> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/install/hardwareRaidSize`);
  };

  /** Start an install */
  postServerInstallStartByServiceName = (
    serviceName: string,
    body: {
      details?: DedicatedServerInstallCustom;
      partitionSchemeName?: string;
      templateName: string;
      userMetadata?: string;
    }
  ): Promise<DedicatedServerTask> => {
    return this.ovh.request('POST', `/dedicated/server/${serviceName}/install/start`, body);
  };

  /** Get installation status */
  getServerInstallStatusByServiceName = (
    serviceName: string
  ): Promise<DedicatedServerInstallationProgressStatus> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/install/status`);
  };

  /** Gives some capabilities regarding the template for the current dedicated server. */
  getServerInstallTemplateCapabilitiesByServiceName = (
    serviceName: string
  ): Promise<DedicatedServerTemplateCaps> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/install/templateCapabilities`);
  };

  /** technical intervention history */
  getServerInterventionByServiceName = (serviceName: string): Promise<number[]> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/intervention`);
  };

  /** Get this object properties */
  getServerInterventionByServiceNameAndInterventionId = (
    interventionId: number,
    serviceName: string
  ): Promise<DedicatedServerIntervention> => {
    return this.ovh.request(
      'GET',
      `/dedicated/server/${serviceName}/intervention/${interventionId}`
    );
  };

  /** Merge a splitted block and route it to the choosen server. You cannot undo this operation */
  postServerIpBlockMergeByServiceName = (
    serviceName: string,
    body: { block: string }
  ): Promise<DedicatedServerTask> => {
    return this.ovh.request('POST', `/dedicated/server/${serviceName}/ipBlockMerge`, body);
  };

  /** Check if given IP can be moved to this server */
  checkServerIpCanBeMovedToByServiceName = (serviceName: string): Promise<void> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/ipCanBeMovedTo`);
  };

  /** Retrieve available country for IP order */
  getServerIpCountryAvailableByServiceName = (
    serviceName: string
  ): Promise<DedicatedServerIpCountryEnum[]> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/ipCountryAvailable`);
  };

  /** Move an Ip failover to this server */
  postServerIpMoveByServiceName = (
    serviceName: string,
    body: { ip: string }
  ): Promise<DedicatedServerTask> => {
    return this.ovh.request('POST', `/dedicated/server/${serviceName}/ipMove`, body);
  };

  /** List all ip from server */
  listServerIpsByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/ips`);
  };

  /** Get the windows license compliant with your server. */
  getServerLicenseCompliantWindowsByServiceName = (
    serviceName: string
  ): Promise<LicenseWindowsOsVersionEnum[]> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/license/compliantWindows`);
  };

  /** Get the windows SQL server license compliant with your server. */
  getServerLicenseCompliantWindowsSqlServerByServiceName = (
    serviceName: string
  ): Promise<LicenseWindowsSqlVersionEnum[]> => {
    return this.ovh.request(
      'GET',
      `/dedicated/server/${serviceName}/license/compliantWindowsSqlServer`
    );
  };

  /** Add your existing windows license serial to this dedicated server. Will be manageable in /license/windows. */
  addServerLicenseWindowsByServiceName = (
    serviceName: string,
    body: { licenseId: string; version: LicenseWindowsOsVersionEnum }
  ): Promise<DedicatedServerTask> => {
    return this.ovh.request('POST', `/dedicated/server/${serviceName}/license/windows`, body);
  };

  /** Retrieve traffic graph values */
  getServerMrtgByServiceName = (
    serviceName: string
  ): Promise<DedicatedServerMrtgTimestampValue[]> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/mrtg`);
  };

  /** List server networkInterfaceController */
  listServerNetworkInterfaceControllerByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/networkInterfaceController`);
  };

  /** Get this object properties */
  getServerNetworkInterfaceControllerByServiceNameAndMac = (
    mac: string,
    serviceName: string
  ): Promise<DedicatedNetworkInterfaceControllerNetworkInterfaceController> => {
    return this.ovh.request(
      'GET',
      `/dedicated/server/${serviceName}/networkInterfaceController/${mac}`
    );
  };

  /** Retrieve traffic graph values */
  getServerNetworkInterfaceControllerMrtgByServiceNameAndMac = (
    mac: string,
    serviceName: string
  ): Promise<DedicatedServerMrtgTimestampValue[]> => {
    return this.ovh.request(
      'GET',
      `/dedicated/server/${serviceName}/networkInterfaceController/${mac}/mrtg`
    );
  };

  /** OLA : Group interfaces into an aggregation */
  postServerOlaAggregationByServiceName = (
    serviceName: string,
    body: { name: string; virtualNetworkInterfaces: string[] }
  ): Promise<DedicatedServerTask> => {
    return this.ovh.request('POST', `/dedicated/server/${serviceName}/ola/aggregation`, body);
  };

  /** OLA : Group interfaces into an aggregation */
  postServerOlaGroupByServiceName = (
    serviceName: string,
    body: { name: string; virtualNetworkInterfaces: string[] }
  ): Promise<DedicatedServerTask> => {
    return this.ovh.request('POST', `/dedicated/server/${serviceName}/ola/group`, body);
  };

  /** OLA : Reset interfaces to default configuration */
  postServerOlaResetByServiceName = (
    serviceName: string,
    body: { virtualNetworkInterface: string }
  ): Promise<DedicatedServerTask> => {
    return this.ovh.request('POST', `/dedicated/server/${serviceName}/ola/reset`, body);
  };

  /** OLA : Ungroup interfaces */
  postServerOlaUngroupByServiceName = (
    serviceName: string,
    body: { virtualNetworkInterface: string }
  ): Promise<DedicatedServerTask[]> => {
    return this.ovh.request('POST', `/dedicated/server/${serviceName}/ola/ungroup`, body);
  };

  /** What is ongoing on this server */
  getServerOngoingByServiceName = (serviceName: string): Promise<DedicatedExposedTask[]> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/ongoing`);
  };

  /** List of dedicated server options */
  listServerOptionByServiceName = (serviceName: string): Promise<DedicatedServerOptionEnum[]> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/option`);
  };

  /** Release a given option */
  deleteServerOptionByServiceNameAndOption = (
    option: DedicatedServerOptionEnum,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request('DELETE', `/dedicated/server/${serviceName}/option/${option}`);
  };

  /** Get this object properties */
  getServerOptionByServiceNameAndOption = (
    option: DedicatedServerOptionEnum,
    serviceName: string
  ): Promise<DedicatedServerOption> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/option/${option}`);
  };

  /** Get the backup storage orderable with your server. */
  getServerOrderableBackupStorageByServiceName = (
    serviceName: string
  ): Promise<DedicatedServerBackupStorageOrderable> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/orderable/backupStorage`);
  };

  /** Get bandwidth orderable with your server. */
  getServerOrderableBandwidthByServiceName = (
    serviceName: string
  ): Promise<DedicatedServerBandwidthOrderable> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/orderable/bandwidth`);
  };

  /** Get vRack bandwidth orderable with your server. */
  getServerOrderableBandwidthvRackByServiceName = (
    serviceName: string
  ): Promise<DedicatedServerBandwidthvRackOrderable> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/orderable/bandwidthvRack`);
  };

  /** Is this feature orderable with your server */
  getServerOrderableFeatureByServiceName = (serviceName: string): Promise<boolean> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/orderable/feature`);
  };

  /** Get IP orderable with your server. */
  getServerOrderableIpByServiceName = (
    serviceName: string
  ): Promise<DedicatedServerIpOrderable> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/orderable/ip`);
  };

  /** Is a KVM orderable with your server */
  getServerOrderableKvmByServiceName = (serviceName: string): Promise<boolean> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/orderable/kvm`);
  };

  /** Is a KVM express orderable with your server */
  getServerOrderableKvmExpressByServiceName = (serviceName: string): Promise<boolean> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/orderable/kvmExpress`);
  };

  /** Is professional use orderable with your server */
  getServerOrderableProfessionalUseByServiceName = (serviceName: string): Promise<boolean> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/orderable/professionalUse`);
  };

  /** Get orderable traffic with your server. */
  getServerOrderableTrafficByServiceName = (
    serviceName: string
  ): Promise<DedicatedServerTrafficOrderable> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/orderable/traffic`);
  };

  /** Get USB keys orderable with your server */
  getServerOrderableUsbKeyByServiceName = (
    serviceName: string
  ): Promise<DedicatedServerUsbKeyOrderableDetails> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/orderable/usbKey`);
  };

  /** Planned interventions for the server */
  getServerPlannedInterventionByServiceName = (serviceName: string): Promise<number[]> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/plannedIntervention`);
  };

  /** Get this object properties */
  getServerPlannedInterventionByServiceNameAndInterventionId = (
    interventionId: number,
    serviceName: string
  ): Promise<DedicatedServerPlannedIntervention> => {
    return this.ovh.request(
      'GET',
      `/dedicated/server/${serviceName}/plannedIntervention/${interventionId}`
    );
  };

  /** Hard reboot this server */
  postServerRebootByServiceName = (serviceName: string): Promise<DedicatedServerTask> => {
    return this.ovh.request('POST', `/dedicated/server/${serviceName}/reboot`);
  };

  /** List of secondary dns domain name */
  listServerSecondaryDnsDomainsByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/secondaryDnsDomains`);
  };

  /** add a domain on secondary dns */
  addServerSecondaryDnsDomainsByServiceName = (
    serviceName: string,
    body: { domain: string; ip?: string }
  ): Promise<void> => {
    return this.ovh.request('POST', `/dedicated/server/${serviceName}/secondaryDnsDomains`, body);
  };

  /** remove this domain */
  deleteServerSecondaryDnsDomainsByServiceNameAndDomain = (
    domain: string,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/dedicated/server/${serviceName}/secondaryDnsDomains/${domain}`
    );
  };

  /** Get this object properties */
  getServerSecondaryDnsDomainsByServiceNameAndDomain = (
    domain: string,
    serviceName: string
  ): Promise<SecondaryDnsSecondaryDNS> => {
    return this.ovh.request(
      'GET',
      `/dedicated/server/${serviceName}/secondaryDnsDomains/${domain}`
    );
  };

  /** Alter this object properties */
  updateServerSecondaryDnsDomainsByServiceNameAndDomain = (
    domain: string,
    serviceName: string,
    body: SecondaryDnsSecondaryDNS
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/dedicated/server/${serviceName}/secondaryDnsDomains/${domain}`,
      body
    );
  };

  /** domain name server informations */
  getServerSecondaryDnsDomainsDnsServerByServiceNameAndDomain = (
    domain: string,
    serviceName: string
  ): Promise<SecondaryDnsSecondaryDNSNameServer> => {
    return this.ovh.request(
      'GET',
      `/dedicated/server/${serviceName}/secondaryDnsDomains/${domain}/dnsServer`
    );
  };

  /** DNS field to temporarily add to your zone so that we can verify you are the owner of this domain */
  getServerSecondaryDnsNameDomainTokenByServiceName = (
    serviceName: string
  ): Promise<SecondaryDnsSecondaryDNSCheckField> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/secondaryDnsNameDomainToken`);
  };

  /** Secondary nameServer available for your Server */
  getServerSecondaryDnsNameServerAvailableByServiceName = (
    serviceName: string
  ): Promise<SecondaryDnsSecondaryDNSNameServer> => {
    return this.ovh.request(
      'GET',
      `/dedicated/server/${serviceName}/secondaryDnsNameServerAvailable`
    );
  };

  /** Get this object properties */
  getServerServiceInfosByServiceName = (serviceName: string): Promise<ServicesService> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/serviceInfos`);
  };

  /** Alter this object properties */
  updateServerServiceInfosByServiceName = (
    serviceName: string,
    body: ServicesService
  ): Promise<void> => {
    return this.ovh.request('PUT', `/dedicated/server/${serviceName}/serviceInfos`, body);
  };

  /** Service monitoring details */
  getServerServiceMonitoringByServiceName = (serviceName: string): Promise<number[]> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/serviceMonitoring`);
  };

  /** Add a new service monitoring */
  addServerServiceMonitoringByServiceName = (
    serviceName: string,
    body: {
      challengeText?: string;
      enabled: boolean;
      interval: DedicatedServerMonitoringIntervalEnum;
      ip: string;
      port: number;
      protocol: DedicatedServerMonitoringProtocolEnum;
      url?: string;
    }
  ): Promise<DedicatedServerServiceMonitoring> => {
    return this.ovh.request('POST', `/dedicated/server/${serviceName}/serviceMonitoring`, body);
  };

  /** Remove this service monitoring */
  deleteServerServiceMonitoringByServiceNameAndMonitoringId = (
    monitoringId: number,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/dedicated/server/${serviceName}/serviceMonitoring/${monitoringId}`
    );
  };

  /** Get this object properties */
  getServerServiceMonitoringByServiceNameAndMonitoringId = (
    monitoringId: number,
    serviceName: string
  ): Promise<DedicatedServerServiceMonitoring> => {
    return this.ovh.request(
      'GET',
      `/dedicated/server/${serviceName}/serviceMonitoring/${monitoringId}`
    );
  };

  /** Alter this object properties */
  updateServerServiceMonitoringByServiceNameAndMonitoringId = (
    monitoringId: number,
    serviceName: string,
    body: DedicatedServerServiceMonitoring
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/dedicated/server/${serviceName}/serviceMonitoring/${monitoringId}`,
      body
    );
  };

  /** Service monitoring alert by email */
  getServerServiceMonitoringAlertEmailByServiceNameAndMonitoringId = (
    monitoringId: number,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/dedicated/server/${serviceName}/serviceMonitoring/${monitoringId}/alert/email`
    );
  };

  /** Add a new email alert */
  addServerServiceMonitoringAlertEmailByServiceNameAndMonitoringId = (
    monitoringId: number,
    serviceName: string,
    body: { email: string; language: DedicatedServerAlertLanguageEnum }
  ): Promise<DedicatedServerEmailAlert> => {
    return this.ovh.request(
      'POST',
      `/dedicated/server/${serviceName}/serviceMonitoring/${monitoringId}/alert/email`,
      body
    );
  };

  /** Remove this Email alert monitoring */
  deleteServerServiceMonitoringAlertEmailByServiceNameAndMonitoringIdAndAlertId = (
    alertId: number,
    monitoringId: number,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/dedicated/server/${serviceName}/serviceMonitoring/${monitoringId}/alert/email/${alertId}`
    );
  };

  /** Get this object properties */
  getServerServiceMonitoringAlertEmailByServiceNameAndMonitoringIdAndAlertId = (
    alertId: number,
    monitoringId: number,
    serviceName: string
  ): Promise<DedicatedServerEmailAlert> => {
    return this.ovh.request(
      'GET',
      `/dedicated/server/${serviceName}/serviceMonitoring/${monitoringId}/alert/email/${alertId}`
    );
  };

  /** Alter this object properties */
  updateServerServiceMonitoringAlertEmailByServiceNameAndMonitoringIdAndAlertId = (
    alertId: number,
    monitoringId: number,
    serviceName: string,
    body: DedicatedServerEmailAlert
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/dedicated/server/${serviceName}/serviceMonitoring/${monitoringId}/alert/email/${alertId}`,
      body
    );
  };

  /** Service monitoring alert by SMS */
  getServerServiceMonitoringAlertSmsByServiceNameAndMonitoringId = (
    monitoringId: number,
    serviceName: string
  ): Promise<number[]> => {
    return this.ovh.request(
      'GET',
      `/dedicated/server/${serviceName}/serviceMonitoring/${monitoringId}/alert/sms`
    );
  };

  /** Create a SMS alert */
  createServerServiceMonitoringAlertSmsByServiceNameAndMonitoringId = (
    monitoringId: number,
    serviceName: string,
    body: {
      fromHour?: number;
      language: DedicatedServerAlertLanguageEnum;
      phoneNumberTo: string;
      smsAccount: string;
      toHour?: number;
    }
  ): Promise<DedicatedServerSmsAlert> => {
    return this.ovh.request(
      'POST',
      `/dedicated/server/${serviceName}/serviceMonitoring/${monitoringId}/alert/sms`,
      body
    );
  };

  /** Remove this SMS alert */
  deleteServerServiceMonitoringAlertSmsByServiceNameAndMonitoringIdAndAlertId = (
    alertId: number,
    monitoringId: number,
    serviceName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/dedicated/server/${serviceName}/serviceMonitoring/${monitoringId}/alert/sms/${alertId}`
    );
  };

  /** Get this object properties */
  getServerServiceMonitoringAlertSmsByServiceNameAndMonitoringIdAndAlertId = (
    alertId: number,
    monitoringId: number,
    serviceName: string
  ): Promise<DedicatedServerSmsAlert> => {
    return this.ovh.request(
      'GET',
      `/dedicated/server/${serviceName}/serviceMonitoring/${monitoringId}/alert/sms/${alertId}`
    );
  };

  /** Alter this object properties */
  updateServerServiceMonitoringAlertSmsByServiceNameAndMonitoringIdAndAlertId = (
    alertId: number,
    monitoringId: number,
    serviceName: string,
    body: DedicatedServerSmsAlert
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/dedicated/server/${serviceName}/serviceMonitoring/${monitoringId}/alert/sms/${alertId}`,
      body
    );
  };

  /** Retrieve hardware informations about this dedicated server */
  getServerSpecificationsHardwareByServiceName = (
    serviceName: string
  ): Promise<DedicatedServerHardwareSpecifications> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/specifications/hardware`);
  };

  /** Retrieve IP capabilities about this dedicated server */
  getServerSpecificationsIpByServiceName = (
    serviceName: string
  ): Promise<DedicatedServerIpOrderable> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/specifications/ip`);
  };

  /** Retrieve network informations about this dedicated server */
  getServerSpecificationsNetworkByServiceName = (
    serviceName: string
  ): Promise<DedicatedServerNetworkSpecifications> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/specifications/network`);
  };

  /** Your own SPLA licenses attached to this dedicated server */
  getServerSplaByServiceName = (serviceName: string): Promise<number[]> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/spla`);
  };

  /** Add a new SPLA license */
  addServerSplaByServiceName = (
    serviceName: string,
    body: { serialNumber: string; type: DedicatedServerSplaTypeEnum }
  ): Promise<number> => {
    return this.ovh.request('POST', `/dedicated/server/${serviceName}/spla`, body);
  };

  /** Get this object properties */
  getServerSplaByServiceNameAndId = (
    id: number,
    serviceName: string
  ): Promise<DedicatedServerSpla> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/spla/${id}`);
  };

  /** Alter this object properties */
  updateServerSplaByServiceNameAndId = (
    id: number,
    serviceName: string,
    body: DedicatedServerSpla
  ): Promise<void> => {
    return this.ovh.request('PUT', `/dedicated/server/${serviceName}/spla/${id}`, body);
  };

  /** Revoke an SPLA license */
  postServerSplaRevokeByServiceNameAndId = (id: number, serviceName: string): Promise<void> => {
    return this.ovh.request('POST', `/dedicated/server/${serviceName}/spla/${id}/revoke`);
  };

  /** Get this object properties */
  getServerStatisticsByServiceName = (serviceName: string): Promise<DedicatedServerRtm> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/statistics`);
  };

  /** Retrieve RTM graph values */
  getServerStatisticsChartByServiceName = (
    serviceName: string
  ): Promise<ComplexTypeChartReturn> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/statistics/chart`);
  };

  /** Get server opened connections */
  getServerStatisticsConnectionByServiceName = (
    serviceName: string
  ): Promise<DedicatedServerRtmConnection[]> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/statistics/connection`);
  };

  /** Get server cpu informations */
  getServerStatisticsCpuByServiceName = (serviceName: string): Promise<DedicatedServerRtmCpu> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/statistics/cpu`);
  };

  /** Server disks */
  getServerStatisticsDiskByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/statistics/disk`);
  };

  /** Get this object properties */
  getServerStatisticsDiskByServiceNameAndDisk = (
    disk: string,
    serviceName: string
  ): Promise<DedicatedServerRtmDisk> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/statistics/disk/${disk}`);
  };

  /** Get disk smart informations */
  getServerStatisticsDiskSmartByServiceNameAndDisk = (
    disk: string,
    serviceName: string
  ): Promise<DedicatedServerRtmDiskSmart> => {
    return this.ovh.request(
      'GET',
      `/dedicated/server/${serviceName}/statistics/disk/${disk}/smart`
    );
  };

  /** Get server load */
  getServerStatisticsLoadByServiceName = (serviceName: string): Promise<DedicatedServerRtmLoad> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/statistics/load`);
  };

  /** Get server memory informations */
  getServerStatisticsMemoryByServiceName = (
    serviceName: string
  ): Promise<DedicatedServerRtmMemory[]> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/statistics/memory`);
  };

  /** Get server motherboard hardware informations */
  getServerStatisticsMotherboardByServiceName = (
    serviceName: string
  ): Promise<DedicatedServerRtmMotherboardHw> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/statistics/motherboard`);
  };

  /** Get server os informations */
  getServerStatisticsOsByServiceName = (serviceName: string): Promise<DedicatedServerRtmOs> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/statistics/os`);
  };

  /** Server partitions */
  getServerStatisticsPartitionByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/statistics/partition`);
  };

  /** Get this object properties */
  getServerStatisticsPartitionByServiceNameAndPartition = (
    partition: string,
    serviceName: string
  ): Promise<DedicatedServerRtmPartition> => {
    return this.ovh.request(
      'GET',
      `/dedicated/server/${serviceName}/statistics/partition/${partition}`
    );
  };

  /** Retrieve partition charts */
  getServerStatisticsPartitionChartByServiceNameAndPartition = (
    partition: string,
    serviceName: string
  ): Promise<ComplexTypeChartReturn> => {
    return this.ovh.request(
      'GET',
      `/dedicated/server/${serviceName}/statistics/partition/${partition}/chart`
    );
  };

  /** Get server PCI devices informations */
  getServerStatisticsPciByServiceName = (serviceName: string): Promise<DedicatedServerRtmPci[]> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/statistics/pci`);
  };

  /** Get server process */
  getServerStatisticsProcessByServiceName = (
    serviceName: string
  ): Promise<DedicatedServerRtmCommandSize[]> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/statistics/process`);
  };

  /** Server raid informations */
  getServerStatisticsRaidByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/statistics/raid`);
  };

  /** Get this object properties */
  getServerStatisticsRaidByServiceNameAndUnit = (
    serviceName: string,
    unit: string
  ): Promise<DedicatedServerRtmRaid> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/statistics/raid/${unit}`);
  };

  /** Raid unit volumes */
  getServerStatisticsRaidVolumeByServiceNameAndUnit = (
    serviceName: string,
    unit: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/dedicated/server/${serviceName}/statistics/raid/${unit}/volume`
    );
  };

  /** Get this object properties */
  getServerStatisticsRaidVolumeByServiceNameAndUnitAndVolume = (
    serviceName: string,
    unit: string,
    volume: string
  ): Promise<DedicatedServerRtmRaidVolume> => {
    return this.ovh.request(
      'GET',
      `/dedicated/server/${serviceName}/statistics/raid/${unit}/volume/${volume}`
    );
  };

  /** Raid unit volume ports */
  getServerStatisticsRaidVolumePortByServiceNameAndUnitAndVolume = (
    serviceName: string,
    unit: string,
    volume: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/dedicated/server/${serviceName}/statistics/raid/${unit}/volume/${volume}/port`
    );
  };

  /** Get this object properties */
  getServerStatisticsRaidVolumePortByServiceNameAndUnitAndVolumeAndPort = (
    port: string,
    serviceName: string,
    unit: string,
    volume: string
  ): Promise<DedicatedServerRtmRaidVolumePort> => {
    return this.ovh.request(
      'GET',
      `/dedicated/server/${serviceName}/statistics/raid/${unit}/volume/${volume}/port/${port}`
    );
  };

  /** Ask for a cooling module replacement */
  postServerSupportReplaceCoolingByServiceName = (
    serviceName: string,
    body: { comment: string; details: string }
  ): Promise<SupportNewMessageInfo> => {
    return this.ovh.request(
      'POST',
      `/dedicated/server/${serviceName}/support/replace/cooling`,
      body
    );
  };

  /** Ask for a broken HDD replacement */
  postServerSupportReplaceHardDiskDriveByServiceName = (
    serviceName: string,
    body: { comment: string; disks: DedicatedServerSupportReplaceHddInfo[]; inverse: boolean }
  ): Promise<SupportNewMessageInfo> => {
    return this.ovh.request(
      'POST',
      `/dedicated/server/${serviceName}/support/replace/hardDiskDrive`,
      body
    );
  };

  /** Ask for a faulty RAM module replacement */
  postServerSupportReplaceMemoryByServiceName = (
    serviceName: string,
    body: { comment: string; details: string; slots?: string[] }
  ): Promise<SupportNewMessageInfo> => {
    return this.ovh.request(
      'POST',
      `/dedicated/server/${serviceName}/support/replace/memory`,
      body
    );
  };

  /** Dedicated server todos */
  getServerTaskByServiceName = (serviceName: string): Promise<number[]> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/task`);
  };

  /** Get this object properties */
  getServerTaskByServiceNameAndTaskId = (
    serviceName: string,
    taskId: number
  ): Promise<DedicatedServerTask> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/task/${taskId}`);
  };

  /** List available time slots for intervention */
  listServerTaskAvailableTimeslotsByServiceNameAndTaskId = (
    serviceName: string,
    taskId: number
  ): Promise<DedicatedPlannedInterventionTimeSlot[]> => {
    return this.ovh.request(
      'GET',
      `/dedicated/server/${serviceName}/task/${taskId}/availableTimeslots`
    );
  };

  /** this action stop the task progression if it's possible */
  postServerTaskCancelByServiceNameAndTaskId = (
    serviceName: string,
    taskId: number
  ): Promise<void> => {
    return this.ovh.request('POST', `/dedicated/server/${serviceName}/task/${taskId}/cancel`);
  };

  /** Schedule intervention */
  postServerTaskScheduleByServiceNameAndTaskId = (
    serviceName: string,
    taskId: number,
    body: { hasPerformedBackup: boolean; wantedBeginingDate: Date }
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/dedicated/server/${serviceName}/task/${taskId}/schedule`,
      body
    );
  };

  /** Terminate your service */
  postServerTerminateByServiceName = (serviceName: string): Promise<string> => {
    return this.ovh.request('POST', `/dedicated/server/${serviceName}/terminate`);
  };

  /** Virtual MAC addresses of the server */
  getServerVirtualMacByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/virtualMac`);
  };

  /** Add a virtual mac to an IP address */
  addServerVirtualMacByServiceName = (
    serviceName: string,
    body: { ipAddress: string; type: DedicatedServerVmacTypeEnum; virtualMachineName: string }
  ): Promise<DedicatedServerTask> => {
    return this.ovh.request('POST', `/dedicated/server/${serviceName}/virtualMac`, body);
  };

  /** Get this object properties */
  getServerVirtualMacByServiceNameAndMacAddress = (
    macAddress: string,
    serviceName: string
  ): Promise<DedicatedServerVirtualMac> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/virtualMac/${macAddress}`);
  };

  /** List of IPs associated to this Virtual MAC */
  listServerVirtualMacVirtualAddressByServiceNameAndMacAddress = (
    macAddress: string,
    serviceName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/dedicated/server/${serviceName}/virtualMac/${macAddress}/virtualAddress`
    );
  };

  /** Add an IP to this Virtual MAC */
  addServerVirtualMacVirtualressByServiceNameAndMacAddress = (
    macAddress: string,
    serviceName: string,
    body: { ipAddress: string; virtualMachineName: string }
  ): Promise<DedicatedServerTask> => {
    return this.ovh.request(
      'POST',
      `/dedicated/server/${serviceName}/virtualMac/${macAddress}/virtualAddress`,
      body
    );
  };

  /** Remove this ip from virtual mac , if you remove the last linked Ip, virtualmac will be deleted */
  deleteServerVirtualMacVirtualAddressByServiceNameAndMacAddressAndIpAddress = (
    ipAddress: string,
    macAddress: string,
    serviceName: string
  ): Promise<DedicatedServerTask> => {
    return this.ovh.request(
      'DELETE',
      `/dedicated/server/${serviceName}/virtualMac/${macAddress}/virtualAddress/${ipAddress}`
    );
  };

  /** Get this object properties */
  getServerVirtualMacVirtualAddressByServiceNameAndMacAddressAndIpAddress = (
    ipAddress: string,
    macAddress: string,
    serviceName: string
  ): Promise<DedicatedServerVirtualMacManagement> => {
    return this.ovh.request(
      'GET',
      `/dedicated/server/${serviceName}/virtualMac/${macAddress}/virtualAddress/${ipAddress}`
    );
  };

  /** List server VirtualNetworkInterfaces */
  listServerVirtualNetworkInterfaceByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/virtualNetworkInterface`);
  };

  /** Get this object properties */
  getServerVirtualNetworkInterfaceByServiceNameAndUuid = (
    serviceName: string,
    uuid: string
  ): Promise<DedicatedVirtualNetworkInterfaceVirtualNetworkInterface> => {
    return this.ovh.request(
      'GET',
      `/dedicated/server/${serviceName}/virtualNetworkInterface/${uuid}`
    );
  };

  /** Alter this object properties */
  updateServerVirtualNetworkInterfaceByServiceNameAndUuid = (
    serviceName: string,
    uuid: string,
    body: DedicatedVirtualNetworkInterfaceVirtualNetworkInterface
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/dedicated/server/${serviceName}/virtualNetworkInterface/${uuid}`,
      body
    );
  };

  /** Disable this VirtualNetworkInterface */
  disableServerVirtualNetworkInterfaceByServiceNameAndUuid = (
    serviceName: string,
    uuid: string
  ): Promise<DedicatedServerTask> => {
    return this.ovh.request(
      'POST',
      `/dedicated/server/${serviceName}/virtualNetworkInterface/${uuid}/disable`
    );
  };

  /** Enable this VirtualNetworkInterface */
  enableServerVirtualNetworkInterfaceByServiceNameAndUuid = (
    serviceName: string,
    uuid: string
  ): Promise<DedicatedServerTask> => {
    return this.ovh.request(
      'POST',
      `/dedicated/server/${serviceName}/virtualNetworkInterface/${uuid}/enable`
    );
  };

  /** Server Vracks (LEGACY) */
  getServerVrackByServiceName = (serviceName: string): Promise<string[]> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/vrack`);
  };

  /** remove this server from this vrack (LEGACY) */
  deleteServerVrackByServiceNameAndVrack = (
    serviceName: string,
    vrack: string
  ): Promise<VrackTask> => {
    return this.ovh.request('DELETE', `/dedicated/server/${serviceName}/vrack/${vrack}`);
  };

  /** Get this object properties */
  getServerVrackByServiceNameAndVrack = (
    serviceName: string,
    vrack: string
  ): Promise<VrackDedicatedServer> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/vrack/${vrack}`);
  };

  /** Retrieve vrack traffic graph values (LEGACY) */
  getServerVrackMrtgByServiceNameAndVrack = (
    serviceName: string,
    vrack: string
  ): Promise<DedicatedServerMrtgTimestampValue[]> => {
    return this.ovh.request('GET', `/dedicated/server/${serviceName}/vrack/${vrack}/mrtg`);
  };
}

export { DedicatedServerHandler };
